import accordeonPl from './pl/accordeon.json'
import articlesPl from './pl/articles.json'
import boxesPl from './pl/boxes.json'
import cardsPl from './pl/cards.json'
import iconListPl from './pl/iconList.json'
import numbersPl from './pl/numbers.json'
import policyPl from './pl/policy.json'

import accordeonEn from './en/accordeon.json'
import articlesEn from './en/articles.json'
import boxesEn from './en/boxes.json'
import cardsEn from './en/cards.json'
import iconListEn from './en/iconList.json'
import numbersEn from './en/numbers.json'
import policyEn from './en/policy.json'

export default {
  pl: {
    accordeon: accordeonPl,
    articles: articlesPl,
    boxes: boxesPl,
    cards: cardsPl,
    iconList: iconListPl,
    numbers: numbersPl,
    policy: policyPl,
  },
  en: {
    accordeon: accordeonEn,
    articles: articlesEn,
    boxes: boxesEn,
    cards: cardsEn,
    iconList: iconListEn,
    numbers: numbersEn,
    policy: policyEn,
  },
}
